import { message } from "antd";
import React from "react";
import Post from "../services/Post";
import Scan from "../assets/images/a-scan.png";

const AttendanceScan = () => {
  const handleCardScan = (e) => {
    e.preventDefault();
    try {
      const data = {
        rfid: e.target.rfid.value,
      };

      const res = Post.AttendanceScan(data);

      if (res.error) {
        message.error(res.error);
        return;
      }

      message.success(`Attendance placed successfully`);
    } catch (error) {
      message.error(error);
    } finally {
      e.target.reset();
    }
  };

  return (
    <>
      <div className="attendance__scan">
        <form onSubmit={handleCardScan}>
          <p className="attendance_text">
            Please Scan Your Card To Mark Attendance!{" "}
          </p>
          <div className="d-attend">
            <input type="text" name="rfid" autoFocus />
            <img src={Scan} />
          </div>
        </form>
      </div>
    </>
  );
};

export default AttendanceScan;
